module.exports = __webpack_public_path__ + "static/img/background.49f1fb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplychain/background.png
// module id = cSeR
// module chunks = 44